import http from '@/libs/http'

export default {
  find(id) {
    return http.get(`/cms/database/${id}`).then(result => result.data)
  },
  databaseAll() {
    return http.get(`/cms/databaseall?activated=true`).then(result => result.data)
  },
  listAll() {
    return http.get(`/cms/databases?activated=true`).then(result => result.data)
  },
  findAll(options) {
    const limit = 10
    const params = Object.assign({
      limit,
      offset: (options.page - 1) * limit,
      sort_by: 'updated_at',
      order: 'desc'
    }, options)
    delete params.page
    // return http.get('/cms/databases', { params }).then(result => result.data)
    return http.get('/cms/databaseall', { params }).then(result => result.data)
  },
  create(model) {
    return http.post('/cms/databases', model).then(result => result.data).catch(error => error)
  },
  update(model) {
    return http.put(`/cms/database/${model.id}`, this._clean(model)).then(result => result.data)
  },
  updateActivated(id, activated) {
    return http.put(`/cms/database/activated/${id}`, { activated }).then(result => result.data)
  },
  delete(id) {
    return http.delete(`/cms/database/${id}`).then(result => result.data)
  },
  testConnection(model) {
    return http.post('/cms/database/test', model).then(result => result.data).catch(error => error)
  },
  getTables(id) {
    return http.get(`/cms/database-tables/${id}`).then(result => result.data)
  },
  getTablesWithParam(options) {
    let id = options.id
    const params = Object.assign({
      typeSource: options.typeSource
    })
    return http.get(`/cms/database-tables/${id}`, { params }).then(result => result.data)
  },
  getTablesWithConnect(model) {
    return http.post(`/cms/database/tableconnects`, model).then(result => result.data)
  },
  _clean(model) {
    const m = Object.assign({}, model)
    delete m.id
    delete m.store_pcds
    delete m.tables
    delete m.views
    return m
  },
  checkDatabaseName(name) {
    return http.post(`/cms/database/check-database`, { name: name }).then(result => result.data.result)
  },
  updateElasticDatabase(model) {
    const id = model.id
    return http.put(`/cms/database/update-elastic-database/${id}`, this._clean(model)).then(result => result.data)
  }
}
